// extracted by mini-css-extract-plugin
export var linkText = "_nk-0";